var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.text)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.progress)+"%")]):_vm._e(),_c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",class:{ 'animate': _vm.animate && _vm.hasStarted },style:(_vm.barStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }